import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Headphones, Images, BookOpen, ChevronRight } from 'lucide-react';

// Mini section component for mobile menu items
const MobileMenuSection = ({ title, description, icon: Icon, onClick, to, bgColor = '#1a1a1a' }) => {
  const content = (
    <div 
      className="flex items-center justify-between w-full py-4 px-5 rounded-lg transition-all hover:scale-[1.01] active:scale-[0.99]"
      style={{
        background: `linear-gradient(135deg, ${bgColor} 0%, #2a2520 100%)`,
        border: '1px solid rgba(198, 167, 94, 0.25)',
      }}
    >
      <div className="flex items-center gap-4">
        <div 
          className="p-2.5 rounded-lg"
          style={{ backgroundColor: 'rgba(198, 167, 94, 0.15)' }}
        >
          <Icon size={22} style={{ color: '#C6A75E' }} />
        </div>
        <div>
          <h3 
            className="text-base font-semibold"
            style={{ 
              fontFamily: '"Cormorant Garamond", Georgia, serif',
              color: '#EFEBE9',
            }}
          >
            {title}
          </h3>
          <p 
            className="text-xs mt-0.5"
            style={{ 
              fontFamily: '"EB Garamond", Georgia, serif',
              color: 'rgba(208, 208, 208, 0.7)',
            }}
          >
            {description}
          </p>
        </div>
      </div>
      <ChevronRight size={20} style={{ color: '#C6A75E' }} />
    </div>
  );

  if (to) {
    return (
      <Link to={to} className="block" data-testid={`mobile-section-${title.toLowerCase().replace(/\s+/g, '-')}`}>
        {content}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className="w-full" data-testid={`mobile-section-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      {content}
    </button>
  );
};

const MobileMenuSections = ({ onOpenExplorer, onOpenAudio }) => {
  const scrollToGallery = () => {
    const element = document.getElementById('galerie');
    if (element) {
      const navbarHeight = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="lg:hidden py-8 px-4"
      style={{ backgroundColor: '#1a1a1a' }}
      data-testid="mobile-menu-sections"
    >
      <div className="max-w-md mx-auto space-y-3">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent to-[#C6A75E]/40" />
          <h2 
            className="text-lg px-3"
            style={{ 
              fontFamily: '"Cormorant Garamond", Georgia, serif',
              color: '#C6A75E',
            }}
          >
            Explorează
          </h2>
          <div className="h-[1px] flex-1 bg-gradient-to-l from-transparent to-[#C6A75E]/40" />
        </div>

        {/* Explorer - ASCUNS PE MOBIL (doar desktop) */}
        {/* 
        <MobileMenuSection
          title="Explorer"
          description="Hartă interactivă cu toate hărțile"
          icon={Compass}
          onClick={onOpenExplorer}
          bgColor="#2C1810"
        />
        */}

        {/* Audio */}
        <MobileMenuSection
          title="Rezumate Audio"
          description="91 episoade narate"
          icon={Headphones}
          onClick={onOpenAudio}
          bgColor="#1e2a1e"
        />

        {/* Galerie */}
        <MobileMenuSection
          title="Galerie"
          description="Colecția completă de hărți"
          icon={Images}
          onClick={scrollToGallery}
          bgColor="#1e1e2a"
        />

        {/* Cronici Istorice */}
        <MobileMenuSection
          title="Cronici Istorice"
          description="Documente și manuscrise istorice"
          icon={BookOpen}
          to="/texte-antice"
          bgColor="#2a1e1e"
        />

        {/* Footer decoration */}
        <div className="flex items-center gap-3 pt-4">
          <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent to-[#C6A75E]/40" />
          <div className="w-1.5 h-1.5 rotate-45 border border-[#C6A75E]/40" />
          <div className="h-[1px] flex-1 bg-gradient-to-l from-transparent to-[#C6A75E]/40" />
        </div>
      </div>
    </section>
  );
};

export default MobileMenuSections;
